module.exports = __webpack_public_path__ + "static/media/1.8e27a95d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row2/1.mp3
// module id = 52
// module chunks = 0